import React from 'react';

import { MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang, permissions } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

const apiStateId = 'change_pw';

class Password extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }
  save = (e) => {
    e.preventDefault();
    model.savePw();
  };
  cancel = (e) => {
    e.preventDefault();
    model.resetApiState('change_pw');
    model.resetPwState();
  };
  render() {
    const { handleChangePw: handleChange } = model;
    const createState = model.getApiState(apiStateId);
    const { invalid, loading } = createState;

    if (createState.error === 'PASSWORD_OLD_INVALID') {
      invalid['password'] = createState.errorMessage;
      createState.error = '';
    }

    if (createState.error === 'PASSWORD_CONFIRM_INVALID') {
      invalid['password2'] = createState.errorMessage;
      createState.error = '';
    }

    return (
      <form className={'mc-setting-change-pw'} onSubmit={this.save}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.change_pw)}</div>
        </div>
        <div className={'mc-form'}>
          <div className={'mc-flex-10-col mc-mlr30'}>
            <div className={'mc-flex-20 mc-flex-start'}>
              <div className={'mc-grow'}>
                <TextField
                  template={6}
                  label={LANG_CONST.current_pw}
                  name={'password'}
                  type={'password'}
                  value={model.input('password')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    handleChange(n, v);
                  }}
                  invalid={invalid}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={6}
                  label={LANG_CONST.new_pw}
                  name={'password1'}
                  type={'password'}
                  value={model.input('password1')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    handleChange(n, v);
                  }}
                  invalid={invalid}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={6}
                  label={LANG_CONST.verification_pw}
                  name={'password2'}
                  type={'password'}
                  value={model.input('password2')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    handleChange(n, v);
                  }}
                  invalid={invalid}
                />
              </div>
            </div>
            <div className={'mc-flex-20 mc-flex-start'}>
              <MCButton tiny to={permissions.PAGES.FORGOT_PASSWORD_PAGE.path} type={'link'}>
                <span className={'mc-primary-420'}>{lang.t(LANG_CONST.text.forgot_pw)}</span>
              </MCButton>
            </div>
          </div>
        </div>
        <div className={'mc-bt mc-flex mc-p30'}>
          {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
          <div className={'mc-grow'}></div>
          {!loading && (
            <MCButton
              onClick={this.cancel}
              medium
              primary
              radius
              light
              label={LANG_CONST.buttons.cancel}
              disabled={loading}
            />
          )}
          <MCButton
            type={'submit'}
            medium
            primary
            radius
            dark
            disabled={loading}
            loading={loading}
            label={LANG_CONST.buttons.save_pw}
          />
        </div>
      </form>
    );
  }
}

export default Password;
